import React, { ChangeEvent } from "react";
import {
  Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import fontWeight from "../../../styles/mui/fontWeight";
import { flexAllEnd } from "../../../styles/mui/styles/display";
import {
  ReferralDetail
} from "../../../models/Referral";
import PaginationItem from "../../../app/common/pagination/components/PaginationItem";
import { colors } from "../../../styles/colors";

export interface PropsFromState {
  referralData: ReferralDetail[];
  handlePageChange: (_e: ChangeEvent<unknown>, page: number) => void;
  count: number;
  page: number;
}

type AllProps = PropsFromState;

const Pagination: React.FC<AllProps> = ({
  referralData,
  handlePageChange,
  count,
  page
}) => {
  return (
    <>
      <Grid size={{ xs: 12 }} pr={6} pb={1}>
        <PaginationItem
          count={count}
          page={page}
          handlePageChange={handlePageChange}
        />
        <Typography
          variant="h4"
          fontWeight={fontWeight[2]}
          color={colors.portalColor[2]}
          pt={1}
          pr={3}
          sx={flexAllEnd}
        >
          Total Records: {referralData.length}
        </Typography>
      </Grid>
    </>
  );
};

export default Pagination;
